import { User } from './user.model';
import { UserData } from './user.model';

interface CreateUser {
  createUser(data: UserData): User;
}

/**
 * UserFactory
 */
export class UserFactory implements CreateUser {
  constructor() {}

  createUser(data: UserData): User {
    let user: User = Object.assign(new User(), data);
    return user;
  }
}



// WEBPACK FOOTER //
// ./src/app/models/user.factory.ts